"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gissi": {
    "e0d099cd": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "case": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b662e953": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "cesi": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f13dc9a4": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "coccetta": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3df926e": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "collespino": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e261509f": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "iungeto": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6762ba4": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "macchie": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71598394": [{
      "hkey": "13464b9a",
      "slug": "piano-dell-ospedale-peschiola",
      "name": "Piano dell'Ospedale-Peschiola",
      "primary": true,
      "skipSearch": false
    }],
    "peschiola": [{
      "hkey": "13464b9a",
      "slug": "piano-dell-ospedale-peschiola",
      "name": "Piano dell'Ospedale-Peschiola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gissi"
    }],
    "90a7a6bc": [{
      "hkey": "13464b9a",
      "slug": "piano-dell-ospedale-peschiola",
      "name": "Piano dell'Ospedale-Peschiola",
      "primary": true,
      "skipSearch": false
    }],
    "pianospedale": [{
      "hkey": "13464b9a",
      "slug": "piano-dell-ospedale-peschiola",
      "name": "Piano dell'Ospedale-Peschiola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9b19f444": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "502f7b2c": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "silvotti": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e736a040": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "terzi": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2e95511": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "skipSearch": false
    }],
    "voltolaio": [{
      "hkey": "55877e79",
      "slug": "gissi",
      "name": "Gissi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;